// 活动接口
/*跨域地址*/
const dev = process.env.dev;
const brApi = process.env.brApi;

export default {
  //数字化证书
  getAgentCert: {
    url: dev + "/c/noauth/agent/digital/cert",
    method: "get",
  },
  //父亲节活动是否开始
  getActivityFatherStart: {
    url: dev + "/c/activity/is/stock/start",
    method: "get",
  },
  //6.1活动产品领取
  getActivityChildStatus: {
    url: dev + "/c/activity/child/product",
    method: "get",
  },
  //父亲节活动产品领取
  getActivityFatherStatus: {
    url: dev + "/c/activity/father/product",
    method: "get",
  },
  //父亲节活动产品领取结果
  getActivityFatherResult: {
    url: dev + "/c/activity/judge/result",
    method: "get",
  },
  //查询该客户是否为活动目标客户
  getActivityWhite: {
    url: dev + "/c/activity/is/white",
    method: "get",
  },
  //活动产品领取
  getActivityProduct: {
    url: dev + "/c/activity/product",
    method: "get",
  },
  // 抖音视频二次支付
  postDacOrderSecondPay: {
    url: dev + "/c/dac/order/second/pay",
    method: "post",
  },
  // 抖音视频二次支付 无验证码
  postNoSmsDacOrderSecondPay: {
    url: dev + "/c/dac/order/second/pay/no/sms",
    method: "post",
  },
  // 抖音视频二次支付 查询订单是否支付
  postDacOrderSecondPayStatus: {
    url: dev + "/c/dac/order/second/pay/status",
    method: "post",
  },
  //彩蛋接口
  getActivityEgg: {
    url: dev + "/c/activity/color/egg",
    method: "get",
  },
  //中秋节活动产品领取
  getActivityMoonDay: {
    url: dev + "/c/activity/moon/day/result",
    method: "get",
  },
  //判断是否领取
  getActivityJudge: {
    url: dev + "/c/activity/judge/result",
    method: "get",
  },
  //判断是否领取
  getActivityReceive: {
    url: dev + "/c/activity/receive/e/book",
    method: "get",
  },
  //2022生日活动奖品领取
  getActivityByBirthday: {
    url: dev + "/c/activity/birthday/result",
    method: "get",
  },
  //生日活动获取回顾页面参数
  getBirthdayData: {
    url: dev + "/c/activity/data/review",
    method: "get",
  },
  //查询活动是否开始
  getActivityStatus: {
    url: dev + "/c/activity/is/start",
    method: "get",
  },
  //领取活动红包
  getActivityRecord: {
    url: dev + "/c/activity/red/package/record",
    method: "get",
  },
  //2023体验金活动入口判断
  experienceStatus: {
    url: dev + "/c/activity/experience/status",
    method: "get",
  },
  //2023体验金活动领取体验金
  experienceReceive: {
    url: dev + "/c/activity/experience/receive",
    method: "get",
  },
  //2023体验金活动获取更多,发短信
  experienceAccess: {
    url: dev + "/c/activity/immediate/access",
    method: "get",
  },
  //判断用户是否是第一次领取
  experienceFirst: {
    url: dev + "/c/activity/is/first",
    method: "get",
  },
  //3月客户促活奖品领取
  getMarchRevitalize: {
    url: dev + "/c/activity/cust/revitalize",
    method: "post",
  },
  //4月客户促活节税保
  getAprilRevitalize: {
    url: dev + "/c/activity/cust/revitalize/April",
    method: "post",
  },
  //4月旅行险奖品领取
  getAprilTravel: {
    url: dev + "/c/activity/travel/insurance",
    method: "post",
  },
  //2023养老体验金活动入口判断
  getPensionStatus: {
    url: dev + "/c/activity/pension/experience/status",
    method: "get",
  },
  //2023养老体验金领取 - 记录活动
  savePensionReceive: {
    url: dev + "/c/activity/pension/experience/receive",
    method: "post",
  },
  //2023养老体验金模板消息提醒顾问
  savePensionMessageSend: {
    url: dev + "/c/activity/pension/experience/message/send",
    method: "post",
  },
  //2023养老体验金提现
  savePensionCard: {
    url: dev + "/c/activity/pension/experience/card",
    method: "post",
  },
  //2023养老体验金打开红包
  saveRedEnvelopeOpen: {
    url: dev + "/c/activity/red/envelope/open",
    method: "post",
  },
  //产品冲刺活动
  getProductSprint: {
    url: dev + "/c/activity/product/sprint",
    method: "post",
  },
  //9月产品
  getPlanPromotiont: {
    url: dev + "/c/activity/plan/promotion",
    method: "post",
  },
  //推文活动
  getDtbMessage: {
    url: dev + "/c/activity/dtb/message/tweet",
    method: "post",
  },
  //客户转介绍活动
  //倒计时
  getActivityCountdown: {
    url: brApi + "/c/web/activity/status",
    method: "post",
  },
  //完整的团队榜单
  getActivityTeamRankPage: {
    url: brApi + "/c/web/activityteam/rank/page",
    method: "post",
  },
  //查询客户可完成任务以及相应的积分
  getActivityTask: {
    url: brApi + "/c/web/activityteammember/task/list",
    method: "post",
  },
  //活动-打卡
  activityclockin: {
    url: brApi + "/c/web/activityclockin/add",
    method: "post",
  },
  //查询健康金明细
  getActivityHealthGold: {
    url: brApi + "/c/web/activityteammember/health/gold/item/list",
    method: "post",
  },
  //创建团队
  createActivityTeam: {
    url: brApi + "/c/web/activityteam/add",
    method: "post",
  },
  //查询团队详情
  getActivityTeam: {
    url: brApi + "/c/web/activityteam/my/team",
    method: "post",
  },
  //加入队伍
  joinActivityTeam: {
    url: brApi + "/c/web/activityinvite/add",
    method: "post",
  },
  //查询打卡日历
  getActivityCalendar: {
    url: brApi + "/c/web/activityclockin/calendar",
    method: "post",
  },
  //加入队伍弹窗
  getActivityTeamDialog: {
    url: brApi + "/c/web/activityinvite/before/invite",
    method: "post",
  },
  //活动-增长保险知识-返回随机素材
  getActivityKnowledge: {
    url: brApi + "/c/web/activityreading/random/material",
    method: "post",
  },
  //活动-推荐
  getActivityRecommend: {
    url: brApi + "/c/web/activityrecommend/add",
    method: "post",
  },
  //活动-分享
  getActivityShare: {
    url: brApi + "/c/web/activityshare/add",
    method: "post",
  },
  //保存PV
  saveActivityPv: {
    url: brApi + "/c/web/activitypv/add",
    method: "post",
  },
  //获取当前登录人信息
  getActivityUserinfo: {
    url: brApi + "/c/web/activityteammember/info",
    method: "post",
  },
  //活动-查询最近一次打卡时长以及统计总打卡天数
  getActivityClock: {
    url: brApi + "/c/web/activityclockin/recently/stat",
    method: "post",
  },
  //随机福利-随机弹出福利
  getActivityRandom: {
    url: brApi + "/c/web/activitypopuprecord/save",
    method: "post",
  },
  //随机福利-保存领取记录
  saveActivityRandomRecord: {
    url: brApi + "/c/web/activitytaskstat/add",
    method: "post",
  },
  //查询转介绍客户明细
  getActivityIntroduce: {
    url: brApi + "/c/web/activityteammember/recommend/actdata",
    method: "post",
  },
  //查询团队成员明细
  getActivityTeamDetails: {
    url: brApi + "/c/web/activityteammember/actdata",
    method: "post",
  },
  // 子渠道下拉框
  changeChannelList: {
    url: brApi + "/c/web/moveres/hkfn/channel/plan/list",
    method: "get",
  },
  //创建数据源
  createFlowShareId: {
    url: brApi + "/c/web/moveres/hkfn/source/data/flow/create",
    method: "post",
  },
  //生成子渠道id
  getChannelSubId: {
    url: brApi + "/c/web/moveres/hkfn/channel/sub/id",
    method: "post",
  },
  //查询顾问微信二维码
  queryAgentQrcode: {
    url: brApi + "/c/web/activityteam/studio/wechat/qrcode",
    method: "post",
  },
  //保存用户需求
  saveUserDemand: {
    url: brApi + "/c/web/activitycustdemand/add",
    method: "post",
  },
  //活动-浏览发送消息
  sendActivityBrowseMsg: {
    url: brApi + "/c/web/activity/message/send",
    method: "post",
  },
  //查询领取红包按钮是否展示以及红包链接
  getActivityRedEnvelope: {
    url: brApi + "/c/web/activityredenvelope/button/show",
    method: "post",
  },
  //是否展示中奖记录假数据
  getActivityPrize: {
    url: brApi + "/c/web/activity/prize/record/banner",
    method: "post",
  },
  //通知顾问创建队伍
  sendActivityTeamMsg: {
    url: brApi + "/c/web/activitywaiter/add",
    method: "post",
  },
  //打开红包链接
  openActivityRedEnvelope: {
    url: brApi + "/c/web/activityredenvelope/acquire",
    method: "post",
  },
  /**分享链接转换二维码Base64*/
  createPosterQrcode: {
    url: brApi + "/c/web/moveres/qrcode",
    method: "get",
  },
  //修改团队名称
  updateActivityTeamName: {
    url: brApi + "/c/web/activityteam/update",
    method: "post",
  },
  //分页查询健康金明细
  getActivityHealthGoldPage: {
    url: brApi + "/c/web/activitytaskstat/health/gold/page",
    method: "post",
  },
  //弹窗-红包瓜分规则
  getActivityRedpacketRule: {
    url: brApi + "/c/web/activitypopuprecord/red/envelop/rule/pop",
    method: "post",
  },
};



// WEBPACK FOOTER //
// ./src/api/activity.js